import React from "react";
import { Chip } from "@mui/material";

const STYLES = {
  APPROVED: {
    label: "✓ Verificado",
    bg: "rgba(74,222,128,0.12)",
    color: "var(--color-success)",
    border: "rgba(74,222,128,0.35)",
  },
  PENDING: {
    label: "⏳ En revisión",
    bg: "rgba(251,191,36,0.12)",
    color: "var(--color-warning)",
    border: "rgba(251,191,36,0.35)",
  },
  REJECTED: {
    label: "✗ Rechazado",
    bg: "rgba(248,113,113,0.12)",
    color: "var(--color-danger)",
    border: "rgba(248,113,113,0.35)",
  },
  NOT_SUBMITTED: {
    label: "Sin enviar",
    bg: "rgba(var(--fg-rgb),0.05)",
    color: "rgba(var(--fg-rgb),0.7)",
    border: "rgba(var(--fg-rgb),0.18)",
  },
};

const VerificationStatusBadge = ({ status, size = "small" }) => {
  const config = STYLES[status] || STYLES.NOT_SUBMITTED;
  return (
    <Chip
      size={size}
      label={config.label}
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        border: `1px solid ${config.border}`,
        fontWeight: 600,
        fontSize: "0.75rem",
        letterSpacing: 0.3,
      }}
    />
  );
};

export default VerificationStatusBadge;
